/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ContactListFilterDto, ContactType } from '@gh/builder-shared-data';
import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import { find } from 'lodash';
import { ContactListInit } from './contact-list-init.model';

export type ContactListFilterType = {
  type: ContactType;
  checked: boolean;
};

export type ContactListFilter = {
  types: ContactListFilterType[];
  showInactive: boolean;
  name?: string;
};

export const ContactListFilterViewMapper = entity<ContactListFilter>({
  types: arrayOf(subentity<ContactListFilterType>({
    type: enumeration(ContactType),
  })),
});

export function contactListFilterToDto(filter: ContactListFilter): ContactListFilterDto {
  return {
    types: filter.types.filter((type) => type.checked).map((type) => type.type),
    showInactive: filter.showInactive,
    name: filter.name,
  };
}

export function contactListInitToFilterDto(init: ContactListInit): ContactListFilterDto {
  return {
    types: init.options.filter((type) => type.allowed).map((type) => type.type),
    showInactive: true,
  };
}

/**
 * Returns new filter object having allowed flag set according to the passed init object
 * @param filter
 * @param init
 */
export function filterAllowedContactTypes(filter: ContactListFilter, init: ContactListInit): ContactListFilter {
  return {
    ...filter,
    types: filter.types.filter((type) => !!find(init.options, { type: type.type, allowed: true })),
  };
}
